import * as React from 'react';
import { useCallback, useEffect } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { SelectedProduct } from '../admin/products/productDetailV2';
import { DotLottleLoader } from '../../components/Loader';

/**
 * The internal (staff) product page, /products/:brandId?productId=. Its list
 * is /products (AllProducts).
 *
 * History, so the browser's Back never gets stuck:
 *   - leaving the product (the page's Back, the skeleton's Back, the error
 *     message's Go back, and the page after Delete product) is ONE push to
 *     /products, so the browser's Back returns to the product;
 *   - a URL without a product id is a redirect to /products that REPLACES
 *     it, so the browser's Back never lands on it again.
 * It used to push /products/:brandId and then /products on both: the
 * browser's Back landed on the id-less URL, whose redirect pushed both
 * again, so nothing before the list could be reached.
 *
 * The props come straight from the URL, so the page never renders a product
 * id the URL no longer has.
 */
export default function SingleProduct() {
  const navigate = useNavigate();
  const { brandId } = useParams();
  const [searchParams] = useSearchParams();
  const productId = searchParams.get('productId');
  const valid = !!productId && !!brandId && !Number.isNaN(Number(brandId));

  useEffect(() => {
    if (!valid) navigate('/products', { replace: true });
  }, [valid, navigate]);

  const goToMainPage = useCallback(() => navigate('/products'), [navigate]);

  if (!valid) return <DotLottleLoader />;
  return <SelectedProduct brandId={Number(brandId)} productId={Number(productId)} onClose={goToMainPage} />;
}
